<template>
<v-flex offset-md1 md10 mb-5>
  <v-layout row wrap class="border-content mt-5 pa-4 mb-5">
    <v-flex sm12 mb-5 >
      <div class="company-header">
        Cupons de Desconto
      </div>
      <table class="tb-cupoms" cellspacing="0" cellspadding="0">
          <thead>
              <tr>
                  <th>Nome</th>
                  <th>Tipo</th>
                  <th>Valor</th>
                  <th>Código</th>
                  <th>Inicio</th>
                  <th>Fim</th>
                  <th>Status</th>
                  <th>Aprovado</th>
                  <th></th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="item in cupoms" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.type | typeFilter }}</td>
                <td>{{ item | currency }}</td>
                <td>{{ item.code }}</td>
                <td>{{ item.start | dateFormat }}</td>
                <td>{{ item.end | dateFormat }}</td>
                <td>{{ item.active | statusFilter }}</td>
                <td>{{ item.approved | approvedFilter }}</td>
                <td>
                    <v-btn icon flat color="grey lighten-1" slot="activator" @click.native.stop="editCupom(item.id)">
                    <v-icon>create</v-icon>
                    </v-btn>
                </td>
              </tr>
          </tbody>
      </table>
    </v-flex>
    <v-flex d-flex sm3>
        <v-layout row wrap>
          <v-flex sm6>
            <div class="v-subheader theme--light">itens por página</div>
          </v-flex>
          <v-flex sm6>
            <v-select
              single-line
              :value="itemsPerPage"
              bottom
              required
              v-model="ipp"
              v-bind:items="comboList"
              @change="refreshList"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm6>
        <v-layout row wrap justify-center>
          <p class="pt-3 pr-2 mb-0">{{pagingText}}</p>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm3>
        <v-layout row wrap justify-end>
          <v-btn
              fab
              rounded
              outlined
              small
              @click.native="prev"
              v-show="currentPage > 1"
              >
                <v-icon light>arrow_back</v-icon>
          </v-btn>
          <v-btn
            fab
            rounded
            outlined
            small
            v-show="currentPage < totalPages"
            @click.native="next"
            >
              <v-icon light>arrow_forward</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
     
  </v-layout>
  <v-btn
      round
      large
      dark
      class="btn-green no-transform"
      @click.native.stop="editCupom(0)">
        <span class="pr-1">
          <v-icon dark>add_circle_outline</v-icon>
        </span>
        Novo Cupom
      </v-btn>
      <CupomDetalhe />
    </v-flex>
      

</template>
<script>
import CupomDetalhe from './cupomDetalhe'
import moment from 'moment'
import 'moment/locale/pt-br'
export default {
  name: 'Cupons',
  components: {
    CupomDetalhe
  },
  data () {
    return {
      comboList: [6, 12, 18, 24, 30],
      ipp: 12
    }
  },
  filters: {
    dateFormat (value) {
      if (value) {
        moment.locale('pt-br')
        return moment(value).format('DD/MM/YYYY')
      }
    },
    currency (item) {
      let newValue = 0
      if (typeof item.amount !== 'number') {
        newValue = parseFloat(item.amount.replace('.', '').replace(',', '.'))
      } else if (typeof item.amount === 'number') {
        newValue = item.amount
      } else {
        return ''
      }
      return item.type === 1 ? parseInt(newValue) + ' %' : 'R$ ' + newValue.toFixed(2)
    },
    statusFilter (value) {
      return value ? 'ativo' : 'inativo'
    },
    approvedFilter (value) {
      return value ? 'sim' : 'não'
    },
    typeFilter (value) {
      return value === 1 ? 'porcentagem' : 'valor'
    }
  },
  methods: {
    next () {
      this.$store.commit('cupomNextPage')
      this.$store.dispatch('getCoupons')
    },
    prev () {
      this.$store.commit('cupomPrevPage')
      this.$store.dispatch('getCoupons')
    },
    refreshList () {
      this.$store.commit('changeItemsPerPage', this.ipp)
      this.$store.dispatch('getCoupons')
    },
    editCupom (item) {
      this.$store.dispatch('selectCupom', item)
    }
  },
  computed: {
    pagingText () {
      return `mostrando de ${((this.$store.getters.cupomCurrentPage - 1) * this.$store.getters.cupomItemsPerPage + 1)} a ${((this.$store.getters.cupomCurrentPage * this.$store.getters.cupomItemsPerPage) > this.$store.getters.cupomTotalItems ? this.$store.getters.cupomTotalItems : (this.$store.getters.cupomCurrentPage * this.$store.getters.cupomItemsPerPage))} de ${this.$store.getters.cupomTotalItems}`
    },
    cupoms () {
      return this.$store.getters.cupoms
    },
    currentPage () {
      return this.$store.getters.cupomCurrentPage
    },
    itemsPerPage () {
      return this.$store.getters.cupomItemsPerPage
    },
    totalPages () {
      return this.$store.getters.cupomTotalPages
    }
  },
  mounted () {
    this.$store.commit('cupomResetPage')
    this.$store.dispatch('getCoupons')
  }
}
</script>
<style>
.tb-cupoms{width: 100%; border-collapse: collapse;}
.tb-cupoms thead th{text-align:left;padding:5px;}
.tb-cupoms tbody td{padding:5px;}
.tb-cupoms thead tr{border-bottom: 1px solid #999}
.tb-cupoms tbody tr{border-bottom: 1px solid #ddd}
</style>



// WEBPACK FOOTER //
// cupons.vue?5ddc5674